import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function Hero() {
  return <section data-section-id="199180" id="languageswitcher" className="bg-secondary-100 text-foreground border-b border-border py-24 md:py-32 lg:py-40 flex items-center justify-center min-h-[85vh]">
      <div className="container mx-auto px-4 md:px-6 flex flex-col items-center text-center">
        <span className="font-sans uppercase tracking-widest text-primary mb-6 text-xs md:text-sm font-medium">
          Engenharia de Precisão
        </span>
        
        <h1 className="font-default font-bold text-5xl md:text-6xl lg:text-7xl tracking-tight mb-6 max-w-4xl text-balance">
          Controle Térmico para Aplicações Críticas
        </h1>
        
        <p className="text-lg md:text-xl text-muted-foreground max-w-2xl mb-10 text-balance">
          A Doctorice é referência em soluções térmicas para ambientes industriais. Desenvolvemos projetos, fabricação e retrofit para salas limpas, data centers e infraestrutura médico-hospitalar.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto">
          <Button asChild size="lg" className="bg-primary text-primary-foreground hover:bg-primary-600 rounded-lg h-12 px-8 text-base shadow-2xs">
            <Link to="#">Português (Brasil)</Link>
          </Button>
          <Button asChild variant="outline" size="lg" className="border-primary text-primary hover:bg-secondary-200 rounded-lg h-12 px-8 text-base">
            <Link to="#">English / Italiano</Link>
          </Button>
        </div>
      </div>
    </section>;
}